import React, { useRef, useState } from "react";
import { Button, Grid, Paper, Typography, TextField } from "@material-ui/core";
import { Link } from "react-router-dom";
import logo from "images/logoAbbott.png";
import routes from "routes";

function LoginVerification() {
  const [pin, setPin] = useState(["", "", "", ""]);
  const pinInputRefs = useRef([]);
  const acceptButtonRef = useRef(null);
  const isPinComplete = pin.every((digit) => digit);

  const updatePinDigit = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(-1);
    const nextPin = [...pin];
    nextPin[index] = digit;
    setPin(nextPin);

    if (!digit) return;

    if (index < pin.length - 1) {
      pinInputRefs.current[index + 1]?.focus();
      return;
    }

    acceptButtonRef.current?.focus();
  };

  const clearPin = () => {
    setPin(["", "", "", ""]);
    pinInputRefs.current[0]?.focus();
  };

  return (
    <Grid
      container
      style={{
        minHeight: "100vh",
        flexDirection: "column",
        flexWrap: "nowrap",
        backgroundColor: "#F6F7FF",
      }}
    >
      <header
        style={{
          width: "100%",
          height: "96px",
          minHeight: "96px",
          display: "flex",
          alignItems: "center",
          padding: "8px 32px",
          backgroundColor: "#c3c3e3",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          boxSizing: "border-box",
        }}
      >
        <img
          src={logo}
          alt="Abbott"
          style={{ height: "80px", width: "auto", objectFit: "contain" }}
        />
      </header>

      <Grid
        item
        xs={12}
        style={{
          width: "100%",
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "32px 16px",
          boxSizing: "border-box",
        }}
      >
        <Paper
          elevation={3}
          style={{
            width: "100%",
            maxWidth: "596px",
            padding: "40px 32px",
            textAlign: "center",
            borderRadius: "8px",
            boxSizing: "border-box",
          }}
        >
          <Typography
            variant="h4"
            style={{ fontSize: "34px", fontWeight: 400, marginBottom: "20px" }}
          >
            Verifica tu acceso
          </Typography>

          <Typography style={{ fontSize: "20px", lineHeight: 1.6 }}>
            Para continuar, ingrese el PIN enviado al correo
          </Typography>
          <Typography
            style={{ fontSize: "20px", lineHeight: 1.6, marginBottom: "32px" }}
          >
            asociado a su cuenta pr*@prueba.com
          </Typography>

          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={1}
            style={{ marginBottom: "48px" }}
          >
            <Grid item>
              <Typography style={{ fontSize: "36px", marginRight: "16px" }}>
                PIN
              </Typography>
            </Grid>
            {[0, 1, 2, 3].map((index) => (
              <Grid item key={index}>
                <TextField
                  variant="outlined"
                  value={pin[index]}
                  inputRef={(element) => {
                    pinInputRefs.current[index] = element;
                  }}
                  onChange={(event) =>
                    updatePinDigit(index, event.target.value)
                  }
                  inputProps={{
                    inputMode: "numeric",
                    style: {
                      textAlign: "center",
                      fontSize: "36px",
                      color: "#4A4A4A",
                      padding: 0,
                      height: "60px",
                    },
                  }}
                  style={{
                    width: "75px",
                    height: "60px",
                    backgroundColor: "#F6F7FF",
                    borderRadius: "8px",
                  }}
                />
              </Grid>
            ))}
          </Grid>

          <Button
            variant="contained"
            color="primary"
            size="large"
            ref={acceptButtonRef}
            disabled={!isPinComplete}
            onClick={clearPin}
            style={{ marginBottom: "36px" }}
          >
            Continuar
          </Button>

          <Typography
            style={{ fontSize: "20px", lineHeight: 1.6, marginBottom: "12px" }}
          >
            ¿No tiene acceso al correo?
          </Typography>

          <Button
            variant="contained"
            color="primary"
            component={Link}
            to={routes.modifyEmailForm}
          >
            Solicitar cambio de correo
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
}
export default LoginVerification;
